<template>
  <v-card
    width="100%"
    outlined
    color="nwhite"
    rounded="lg"
    class="mb-4 mt-4"
    :dark="this.$vuetify.theme.dark"
    v-if="isCard"
  >
    <v-card-subtitle class="text-h4 font-weight-bold primary--text">
      {{ Usergreeting }}
    </v-card-subtitle>
  </v-card>
  <h2 v-else class="my-8 adaprimary--text">{{ Usergreeting }}</h2>
</template>
<script>
export default {
  props: {
    Usergreeting: {
      type: String,
      required: true
    },
    isCard: {
      type: Boolean
    }
  }
};
</script>
